import * as React from 'react';
import {Dropdown, DropdownItemProps, FormField} from "semantic-ui-react";
import {Graph, Node} from "../../model/Graph";

interface OwnProps {
  graph: Graph;
  onLayerChanged: (layer: Node) => void;
}

type LayerSelectProps = OwnProps;

const prepareOptions = (graph: Graph): DropdownItemProps[] => {
  const options: DropdownItemProps[] = [];

  graph.getRoot().children().forEach(layer => {
    options.push({
      key: layer.getId(),
      text: layer.getName(),
      value: layer.getId(),
    })
  })

  return options;
}

const LayerSelect = (props: LayerSelectProps) => {

  const handleLayerChanged = (layerId: string | undefined) => {
    if(!layerId) {
      props.graph.setDefaultLayerAsActive();
    }

    const layer = props.graph.getNode(layerId as string);

    if(!layer) {
      props.graph.setDefaultLayerAsActive();
    }

    props.graph.setAsActiveLayer(layer as Node);

    props.onLayerChanged(props.graph.getActiveLayer());
  }

  return <FormField inline={true}>
    <Dropdown inline={true}
              value={props.graph.getActiveLayer().getId()}
              onChange={(e, data) => handleLayerChanged(data.value as string | undefined)}
              options={prepareOptions(props.graph)} />
  </FormField>
};

export default LayerSelect;
